var alignmentStyle = {"alignLeft":"vMRdb","textWrapNowrap":"NqUQw","alignRight":"OoHdn","alignCenter":"_8FpLx","sizeFullWidth":"xVsGt","renderedInTable":"-j2aY","sizeOriginal":"H0fE-","sizeContent":"kcvVJ","sizeSmall":"k5Eqc","sizeSmallCenter":"_0OwUc","flex":"_41mW7","LEFT":"RK1F6","CENTER":"l91Zk","RIGHT":"MxIAb","AUTO":"DZA4J","JUSTIFY":"Gx5nM"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-9b569fff.js.map
